// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Company locations page component.
 * Displays a table of locations associated with the company.
 */
import { HardfinTabCardWrapper } from '@/components/hardfin-tab-card-wrapper';
import { getCustomer } from '@/customer/api/get-customer';
import { CustomerErrorBoundary } from '@/customer/components/customer-error-boundary';
import { CustomerSiteTable } from '@/customer/components/site-table';
import { Stack } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';

export const Route = createFileRoute('/_app/companies/$companyKey/locations')({
  component: CompanyLocationsRoute,
});

function CompanyLocationsRoute() {
  const { companyKey } = Route.useParams();

  return (
    <CustomerErrorBoundary>
      <CompanyLocationsContent companyKey={companyKey} />
    </CustomerErrorBoundary>
  );
}

function CompanyLocationsContent(props: { companyKey: string }) {
  const { data } = useSuspenseQuery({
    queryKey: ['customer', props.companyKey],
    queryFn: () => getCustomer(props.companyKey),
  });

  return (
    <HardfinTabCardWrapper title="Locations">
      <Stack paddingTop={2}>
        <Suspense>
          <CustomerSiteTable customer={data.customer} />
        </Suspense>
      </Stack>
    </HardfinTabCardWrapper>
  );
}
